import { ObjectFieldsChecker } from "../../../../../../../tools/ObjectFieldsChecker";
import { RevealRaidTargetsResultDto } from "../../../../../../networking/data/responses/raid/RevealRaidTargetsResultDto";
import { DiceRollRaidGameResultType } from "./DiceRollRaidGameResultType";
import { RaidTarget } from "./RaidTarget";

export class RaidTargetsData {
    public readonly diceRollRaidGameResult: DiceRollRaidGameResultType;
    public readonly diceRollRaidTargets: Array<RaidTarget>;

    public constructor(dto: RevealRaidTargetsResultDto) {
        ObjectFieldsChecker.throwIfInvalidFields(dto, ["items", "gameResult"])
        this.diceRollRaidTargets = [];
        for (const raidTargetDto of dto.items) {
            this.diceRollRaidTargets.push(new RaidTarget(raidTargetDto));
        }
        this.diceRollRaidGameResult = DiceRollRaidGameResultType[dto.gameResult as keyof typeof DiceRollRaidGameResultType];
    }
}
